import { render, staticRenderFns } from "./HorseOnline.vue?vue&type=template&id=dbb40c72&"
import script from "./HorseOnline.vue?vue&type=script&lang=js&"
export * from "./HorseOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports